import { Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  label?: string;
  rightSection?: React.ReactNode;
  onClick?: () => void;
};

export function AISetTitle({ label = 'Suggested actions', rightSection, onClick }: Props) {
  return (
    <Flex
      onClick={onClick}
      px="xs"
      gap="xxxs"
      align="center"
      style={{
        height: 22,
        background: 'rgba(0, 0, 0, 0.25)',
        borderRadius: 'var(--mantine-radius-xl)',
        display: 'inline-flex',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <Text size="textXs" fw={FONT_WEIGHTS.bold} c="white">
        {label}
      </Text>
      {rightSection}
    </Flex>
  );
}
